import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import {
  IContactUsBreadcrumbData,
  IBreadcrumbData,
  IEquisBreadcrumbTree,
  ContactUsTypes,
} from 'src/app/shared/models/breadcrumb';
import { environment } from 'src/environments/environment';
import { InicioNode, CANode } from './breadcrumbFactory';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  initialBreadcrumbs: IEquisBreadcrumbTree[] = [InicioNode, CANode];

  breadcrumbData = new BehaviorSubject<IBreadcrumbData | null>(null);

  constructor(private http: HttpClient) {}

  public setBreadcrumb(breadcrumbData: IBreadcrumbData): void {
    if (breadcrumbData) {
      this.breadcrumbData.next(breadcrumbData);
    }
  }

  public resetBreadcrumb(): void {
    this.breadcrumbData.next(null);
  }

  public getBreadcrumb(): Observable<
    Array<IEquisBreadcrumbTree | IContactUsBreadcrumbData>
  > {
    return this.breadcrumbData.pipe(
      mergeMap(data => {
        if (data !== null) {
          if (
            Object.values(ContactUsTypes).includes(data.id as ContactUsTypes)
          ) {
            return this.getContactUsBreadcrumbData(data);
          }

          return this.http
            .get<IEquisBreadcrumbTree[]>(
              this.buildUrl(
                environment.urls.faqs.getBreadcrumbById,
                data.type,
                data.id,
                data.parentId,
              ),
            )
            .pipe(
              catchError(error => {
                console.error('Error fetching breadcrumbs:', error);
                return of([]);
              }),
            );
        }
        return of([]);
      }),
      map(breadcrumbs => [...this.initialBreadcrumbs, ...breadcrumbs]),
    );
  }

  private getContactUsBreadcrumbData(
    data: any,
  ): Observable<Array<IEquisBreadcrumbTree | IContactUsBreadcrumbData>> {
    const contactChannelsBreadcrumb = {
      path: '/contacto',
      title: 'Canales de atención',
    };
    const phonesBreadcrumb = {
      path: '/telefonos',
      title: 'Teléfonos',
    };

    if (data.id === ContactUsTypes.CONTACT_CHANNELS) {
      return of([contactChannelsBreadcrumb]);
    }

    return of([contactChannelsBreadcrumb, phonesBreadcrumb]);
  }

  private buildUrl(base: string, ...params: (string | undefined)[]): string {
    return `${base}${params
      .filter(p => p !== null && p !== undefined)
      .join('/')}`;
  }
}
